// 登录相关api
import request from '@/lib/request'

// 登录
// @username 用户名
// @password 密码
// =>token 返回token
function Login({ username, password }) {
  return request
    .post(
      '/institutionAdmin/login',
      {
        account: username,
        password: password
      }
    )
    .then(response => {
      return response.data
    })
}

// 注册
// @userinfo 注册信息
// {
//   phoneno : '13800099899'
// }
// => token 返回 token
// function Regist (userinfo) {
//   return request.post('/register', userinfo)
//     .then(response => {
//       return response.data
//     })
// }

export default {
  Login
}
